import React from 'react';
import { motion } from 'framer-motion';
import { XIcon, CheckIcon } from 'lucide-react';
const before = ['Przewijasz internet w poszukiwaniu pomysłu, który może się uda', 'Nie wiesz, jakie materiały będą potrzebne', 'Trafiasz na projekt, do którego trzeba dokupić specjalny zestaw', 'Próbujesz rozszyfrować niejasną instrukcję', 'Zapał gaśnie, zanim w ogóle zaczniecie budować'];
const after = ['Wybierasz projekt według wieku, czasu i poziomu trudności', 'Widzisz listę materiałów, zanim zaczniecie', 'Budujecie z tego, co jest w domu: pudełek, rolek, butelek i słomek', 'Idziecie krok po kroku za czytelnymi obrazkami', 'Testujecie, poprawiacie i cieszycie się gotowym wynalazkiem'];
export function PainSection() {
  return <section className="w-full bg-background px-5 py-12 sm:py-20" data-id="element-152" data-mp="2g76epr402dg0">
      <div className="mx-auto max-w-5xl" data-id="element-153" data-mp="22at3gzq2789z">
        <div className="mx-auto max-w-2xl text-center" data-id="element-154" data-mp="278l2set19wo7">
          <h2 className="font-display text-2xl font-bold leading-tight text-foreground sm:text-4xl" data-id="element-155" data-mp="2781kgwzh169n">
            Mniej „Co będziemy robić?”. Więcej „Patrz, działa!”.
          </h2>
        </div>

        <div className="mt-10 grid gap-6 md:grid-cols-2" data-id="element-156" data-mp="3nknpgzt1l2bz">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.2
        }} transition={{
          duration: 0.5
        }} className="rounded-2xl border-l-4 border-accent/50 bg-accent-soft p-6 sm:p-8" data-id="element-157" data-mp="5fkewzkb3y46">
            <h3 className="mb-5 text-lg font-bold text-foreground sm:text-xl" data-id="element-158" data-mp="33xycse5bz3d7">Zwykłe szukanie zajęcia</h3>
            <ul className="space-y-3" data-id="element-159" data-mp="3imm4uafywuye">
              {before.map(item => <li key={item} className="flex items-start gap-3" data-id="element-160" data-mp="3dvvzuybgeu48">
                  <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-accent/15 text-accent-strong" data-id="element-161" data-mp="3dtjbo3f3rniq">
                    <XIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-162" data-mp="2l7gqosf0760t" />
                  </span>
                  <span className="text-sm leading-relaxed text-foreground/80" data-id="element-163" data-mp="p4bxp8c8whoo">{item}</span>
                </li>)}
            </ul>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.2
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} className="rounded-2xl border-l-4 border-primary bg-secondary p-6 sm:p-8" data-id="element-164" data-mp="u0k868fhzmpi">
            <h3 className="mb-5 text-lg font-bold text-primary-strong sm:text-xl" data-id="element-165" data-mp="b412xu7teiy8">
              Z Pracownią Małego Wynalazcy
            </h3>
            <ul className="space-y-3" data-id="element-166" data-mp="f4uuqyodohwe">
              {after.map(item => <li key={item} className="flex items-start gap-3" data-id="element-167" data-mp="k4zces10vio7">
                  <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-success/15 text-success" data-id="element-168" data-mp="1qkta1ka5g062">
                    <CheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-169" data-mp="1vj323m0kukng" />
                  </span>
                  <span className="text-sm leading-relaxed text-foreground/80" data-id="element-170" data-mp="25o2u1fh0zvxd">{item}</span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}